import axios from "../../config/axiosConfig";
import { CREATE_USER, GET_USERS, USER_REQUEST, DELETE_USER, UPDATE_USER, USER_REQUEST_FAILURE } from "../types";

export const getUsers = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: USER_REQUEST });
      const { auth } = getState();
      const user = auth.user || auth.superUser;
      return axios.get("/user/getAll", { params: { customerId: auth?.user?.Customer_Id }}).then((response) => {
        if (response.data) {
          dispatch({ type: GET_USERS, payload: response.data });
        }  
      }).catch((error) => {
        console.error(error);
        dispatch({ type: USER_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: USER_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAllUsers = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: USER_REQUEST });
      return axios.get("/user/getAll").then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: USER_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: USER_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createUser = (user) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: USER_REQUEST });
      const { auth } = getState();
      return axios.post("/user/add", user, { params: { userId: auth.user?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_USER, payload: response.data });
        } else {
          dispatch({
            type: USER_REQUEST_FAILURE,
            error: "User create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: USER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: USER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateUser = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: USER_REQUEST });
      const { auth } = getState();
      return axios.put("/user/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_USER,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: USER_REQUEST_FAILURE,
            error: "User update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: USER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: USER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteUser = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: USER_REQUEST });
      return axios.delete(`/user/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_USER, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: USER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: USER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
